import { useOnboardingStore } from '../../stores/useOnboardingStore';
import styles from './WelcomeVideoModal.module.css';

const WelcomeVideoModal = () => {
  const showVideoModal = useOnboardingStore((s) => s.showVideoModal);
  const markVideoSeen = useOnboardingStore((s) => s.markVideoSeen);
  const trackEvent = useOnboardingStore((s) => s.trackEvent);

  if (!showVideoModal) return null;

  const handleWatch = () => {
    trackEvent({ eventType: 'video_started' });
    markVideoSeen();
  };

  const handleSkip = () => {
    markVideoSeen();
  };

  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>
        <button className={styles.closeBtn} onClick={handleSkip}>
          &times;
        </button>

        <h2 className={styles.title}>Bienvenido a Prikly</h2>
        <p className={styles.subtitle}>
          Te preparamos una guía rápida para que configures tu negocio en minutos
        </p>

        <div className={styles.videoContainer}>
          <iframe
            src="https://www.youtube.com/embed/i14LucE45O0?rel=0"
            title="Bienvenido a Prikly"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            className={styles.videoIframe}
          />
        </div>

        <div className={styles.actions}>
          <button className={styles.btnPrimary} onClick={handleWatch}>
            Comenzar
          </button>
          <button className={styles.btnSecondary} onClick={handleSkip}>
            Saltar por ahora
          </button>
        </div>
      </div>
    </div>
  );
};

export default WelcomeVideoModal;
